const DESKTOP_BREAKPOINT = 700

const DeviceMixin = {
  data() {
    return {
      isDesktop: window.innerWidth >= DESKTOP_BREAKPOINT,
    }
  },

  methods: {
    _onResize() {
      this.isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT
    },
  },

  mounted() {
    this._mq = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`)
    this._handler = (e) => { this.isDesktop = e.matches }
    this._mq.addEventListener('change', this._handler)
    window.addEventListener('resize', this._onResize)
  },

  beforeDestroy() {
    if (this._mq) this._mq.removeEventListener('change', this._handler)
    window.removeEventListener('resize', this._onResize)
  },
}

export default DeviceMixin
